const Heading = {
	baseStyle: {
		color: 'gray.800',
	},
}

export default Heading
